export default {
  path: '/lvy-platform-content-manage-rules',
  component: () => import('./LVYPlatformContentManageRules'),
  meta: {
    title: '青藤之恋平台信息内容管理规范',
    designWidth: 750,
    expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (中国标准时间)',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
